// Harici Personel Yönetimi: tablo sütunları ve form alanları. Alan adları
// ExternalPersonnels belgelerindeki (Türkçe) adlardır; metinler
// externalPersonnel.fields.<anahtar> altındadır.

// Belge alanı → metin anahtarı
export const FIELD_KEYS = {
  'Adı': 'name',
  'Soyadı': 'surname',
  'Adres': 'address',
  'Telefon': 'phone',
  'E-Posta': 'email',
  'Kurum': 'institution',
  'Ünvan': 'title',
  'Uzmanlık': 'specialty',
  'Ana Bilim Dalı': 'department',
  'Personel Tipi': 'personnelType',
  'Durum': 'status',
  'Bilgi': 'info',
};

// Formdaki alanlar (eski formdaki sıra; hepsi zorunluydu)
export const FORM_FIELDS = ['Adı', 'Soyadı', 'E-Posta', 'Telefon', 'Adres', 'Kurum', 'Ünvan', 'Uzmanlık', 'Ana Bilim Dalı', 'Personel Tipi', 'Durum', 'Bilgi'];

export const PERSONNEL_COLUMNS = {
  'Adı': { type: 'text', width: 160 },
  'Soyadı': { type: 'text', width: 160 },
  'Telefon': { type: 'text', width: 160 },
  'E-Posta': { type: 'text', width: 240 },
  'Kurum': { type: 'text', width: 220 },
  'Ünvan': { type: 'text', width: 160 },
  'Personel Tipi': { type: 'text', width: 160 },
  'Durum': { type: 'select', width: 120 },
  'Uzmanlık': { type: 'text', width: 180 },
  'Ana Bilim Dalı': { type: 'text', width: 200 },
  'Adres': { type: 'text', width: 260 },
};

export const COLUMN_KEYS = Object.keys(PERSONNEL_COLUMNS);
// Eski varsayılan: Adres, Uzmanlık ve Ana Bilim Dalı gizli
export const DEFAULT_VISIBLE_COLUMNS = Object.fromEntries(COLUMN_KEYS.map((key) => [key, !['Adres', 'Uzmanlık', 'Ana Bilim Dalı'].includes(key)]));
export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['Adı', 'Soyadı'];

// Durum kayıtlı değerleri küçük harflidir ('aktif' / 'inaktif'); eski düzenleme
// formu 'Aktif' / 'İnaktif' yazabiliyordu, bu yüzden karşılaştırmalar normalleştirilir
export const STATUS_VALUES = ['aktif', 'inaktif'];
export const DEFAULT_FILTERS = { 'Durum': 'aktif' };
// Metin süzgeçleri ve arama en az 3 karakterle uygulanır (eski kural)
export const MIN_CHARS = 3;

/**
 * Lower case with the Turkish letters (İ → i, I → ı). The capitals are
 * replaced before lower-casing: the old helper did it after, when they were
 * already gone ("İnaktif" became "i̇naktif" and never matched "inaktif").
 */
export const normalizeTurkishText = (text) => {
  if (!text) return '';
  return String(text)
    .replace(/İ/g, 'i')
    .replace(/I/g, 'ı')
    .toLowerCase()
    .replace(/̇/g, '');
};

/** 'aktif' / 'inaktif' / '' from any stored spelling. */
export const statusOf = (value) => {
  const normalized = normalizeTurkishText(value);
  if (normalized === 'aktif') return 'aktif';
  if (normalized === 'inaktif') return 'inaktif';
  return '';
};

export const getFilterState = (key, value) => {
  if (value === undefined || value === null || String(value) === '') return 'off';
  if (key !== 'Durum' && String(value).trim().length < MIN_CHARS) return 'pending';
  return 'applied';
};
